// Autosave status shown in the review footer. Reflects the debounced write-through
// state for the open session (Enregistrement… / Enregistré ✓ / Échec). Renders
// nothing before the first save so the footer stays quiet until there's something
// to report.
import type { SaveStatus } from '@/lib/bulk-add/bulk-session';

interface SaveIndicatorProps {
  status: SaveStatus | undefined;
}

const LABELS: Record<SaveStatus, { icon: string; text: string }> = {
  saving: { icon: 'progress_activity', text: 'Enregistrement…' },
  saved: { icon: 'check', text: 'Enregistré' },
  error: { icon: 'cloud_off', text: 'Échec — nouvelle tentative' },
};

/** Small footer indicator for the open session's autosave state. */
export function SaveIndicator({ status }: SaveIndicatorProps) {
  if (!status) return null;
  const { icon, text } = LABELS[status];
  return (
    <output className={`bulk-save bulk-save--${status}`} aria-live="polite">
      <span className="material-symbols-rounded bulk-save__icon" aria-hidden="true">
        {icon}
      </span>
      {text}
    </output>
  );
}
